import { OfferingCategory } from "@albertine/types";

// Re-export for backward compatibility
export { OfferingCategory };

import type { ServiceLanguage } from "@albertine/i18n";
import { translation } from "albertine-shared-web/i18n";
import { z } from "zod";
import type { TravelQuickRequestSubtype } from "./QuickRequests";

export const OfferingCategoryUncategorizedKey = "uncategorized";

const CategoriesWithUncategorizedList = [
    ...OfferingCategory.options,
    OfferingCategoryUncategorizedKey,
] as const;
export const CategoriesWithUncategorized = z.enum(CategoriesWithUncategorizedList);
export type CategoriesWithUncategorized = z.infer<typeof CategoriesWithUncategorized>;

export function categoryDisplayName(
    offeringCategory: CategoriesWithUncategorized,
    serviceLanguage: ServiceLanguage,
) {
    return translation(`offering_category.${offeringCategory}`, {
        lng: serviceLanguage,
    });
}

export type FilterByCategory = {
    id: CategoriesWithUncategorized;
    name: string;
};

export const CategoryAndRequestCategory = z.object({
    offeringCategory: OfferingCategory.optional().nullable(),
});

export type CategoryAndRequestCategory = z.infer<typeof CategoryAndRequestCategory>;

export function mapTravelQuickRequestSubtypeToOfferingCategory(
    subtype: TravelQuickRequestSubtype | undefined,
): OfferingCategory {
    if (subtype) {
        switch (subtype) {
            case "flight":
                return "flight";
            case "accommodation":
                return "accommodation";
            case "transportation":
                return "transportation";
            default:
                return "travelItinerary";
        }
    }
    return "travelItinerary";
}
